import React, { useMemo } from 'react';
import fp from 'lodash/fp';
import { withTranslation, useTranslation as useI18nTranslation, Namespace } from 'react-i18next';
import { TFunction } from 'i18next';

import { setHtml } from 'Modules/ui';

import { ValuesType, ComplexContentType, ContentType } from './types';


const htmlPreamble = '</>';
const isHtml = fp.startsWith(htmlPreamble);
const unwrapHtml = fp.replace(htmlPreamble, '');

const customTranslateFn = (t: TFunction) => (
    content: ContentType,
    values?: ValuesType,
): React.ReactNode => {
    const translateComplexExpression = ({
        key,
        values: valuesInner,
        translatedValues,
    }: ComplexContentType) => t(key, {
        ...valuesInner,
        ...translatedValues &&
            fp.mapValues(customTranslateFn(t), translatedValues),
    });

    if (fp.isNil(content))
        return '';

    if (fp.isObject(content))
        return translateComplexExpression(content);

    const translated = t(content, values);
    return isHtml(translated)
        ? <span {...setHtml(unwrapHtml(translated))} />
        : translated;
};

export const translate = (namespaces: Namespace = []) => Component =>
    // current type withTranslation props no correct
    // @ts-ignore
    withTranslation(namespaces)(({ t, ...props }) => (
        <Component t={customTranslateFn(t)} {...props} />
    ));

export const useTranslation = (namespaces: Namespace = []) => {
    const { t, i18n } = useI18nTranslation(namespaces);
    const customT = useMemo(
        () => customTranslateFn(t),
        [t],
    );
    return {
        t: customT,
        i18n,
    };
};

export * from './types';
